export default __webpack_public_path__ + "static/media/thumbnail-w-cushion.75b2b2d2.png";